import { useSimpleFormIterator, useTranslate } from 'ra-core';
import { Plus, ListChecks, ListPlus, ListTodo, Camera } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../../../components/ui/dropdown-menu';

export function AddTaskButton() {
  const { add } = useSimpleFormIterator();
  const translate = useTranslate();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger render={<Button type="button" variant="outline" />}>
        <Plus />
        {translate('ra.action.add')}
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuItem onClick={() => add({ type: 'TASK' })}>
          <ListTodo />
          {translate('moonstar.checklists.tasks.types.TASK')}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => add({ type: 'OPEN_ENDED' })}>
          <ListPlus />
          {translate('moonstar.checklists.tasks.types.OPEN_ENDED')}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => add({ type: 'RADIO_SELECT' })}>
          <ListChecks />
          {translate('moonstar.checklists.tasks.types.RADIO_SELECT')}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => add({ type: 'PHOTO_UPLOAD' })}>
          <Camera />
          {translate('moonstar.checklists.tasks.types.PHOTO_UPLOAD')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
